<template>
  <base-dialog
    v-model="show"
    max-width="560px"
    title="Tạo mới dữ liệu từ Shapefile"
    @close="close"
  >
    <v-form ref="form" v-model="valid" lazy-validation class="pa-2">
      <div class="mb-3 text-body-2">
        Tải file zip chứa shapefile (.shp, .shx, .dbf, .cpg) để ghi đè, thêm
        mới hoặc cập nhật theo trường khóa.
      </div>
      <v-radio-group v-model="mode" hide-details class="mt-0" mandatory>
        <v-radio value="append" label="Thêm mới vào dữ liệu hiện tại"></v-radio>
        <v-radio
          value="updateOrCreate"
          label="Cập nhật hoặc thêm mới theo trường khóa"
        ></v-radio>
        <v-radio
          value="overwrite"
          label="Ghi đè toàn bộ dữ liệu hiện tại"
        ></v-radio>
      </v-radio-group>
      <field-group
        v-if="mode === 'updateOrCreate'"
        v-model="keyField"
        item-text="name"
        item-value="code"
        :items="keyFieldItems"
        :rules="keyFieldRules"
        label="Trường khóa"
        hint="Nếu giá trị trường này đã có thì cập nhật, chưa có thì thêm mới"
        persistent-hint
        typeInput="v-select"
        class="mt-3"
      />
      <v-alert
        v-if="mode === 'overwrite'"
        dense
        text
        type="warning"
        class="mt-3 mb-2"
      >
        Dữ liệu hiện tại sẽ bị xóa và thay bằng shapefile mới.
      </v-alert>
      <field-group
        v-model="file"
        typeInput="field-file-input"
        :rules="fileRules"
        accept=".zip"
        title="Tải Shapefile (.zip)"
        class="mt-3"
      />
    </v-form>
    <template #extra-btn>
      <base-button color="primary" :loading="loading" @click="onSubmit">
        Tải lên
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import fieldGroup from '@components/field/field-group.vue'
import { ConfirmBuilder } from '@utils'

export default {
  name: 'FeatureImportDialog',
  components: { fieldGroup },
  props: {
    detailId: { type: [Number, String], required: true },
    fields: { type: Array, default: () => [] },
  },
  data: () => ({
    show: false,
    loading: false,
    valid: true,
    mode: 'append',
    keyField: null,
    file: null,
    fileRules: [
      (v) => {
        if (Array.isArray(v)) return v.length > 0 || 'File không thể bỏ trống'
        return !!v || 'File không thể bỏ trống'
      },
    ],
  }),
  computed: {
    keyFieldItems() {
      return (this.fields || []).filter(
        (field) =>
          !['geometry', 'array', 'region-field'].includes(field.type) &&
          !['version', 'id', 'gid', 'geom'].includes(field.code)
      )
    },
    keyFieldRules() {
      if (this.mode !== 'updateOrCreate') return []
      return [(v) => !!v || 'Cần chọn trường khóa']
    },
  },
  methods: {
    open() {
      this.mode = 'append'
      this.keyField = null
      this.file = null
      this.loading = false
      this.show = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation()
      })
    },
    close() {
      this.show = false
      this.loading = false
    },
    async onSubmit() {
      if (this.$refs.form && !this.$refs.form.validate()) return
      if (!this.file) return
      if (this.mode === 'updateOrCreate' && !this.keyField) return
      if (this.mode === 'overwrite') {
        const confirm = new ConfirmBuilder()
        confirm
          .addText(
            'Hành động này <b>xóa toàn bộ dữ liệu hiện tại</b> và thay bằng shapefile mới.'
          )
          .setTitle('confirm.title')
          .setOption({ color: 'error' })
          .setType('delete')
        if (!(await confirm.confirm())) return
      }
      const rawFile = Array.isArray(this.file) ? this.file[0] : this.file
      if (!rawFile) return
      const formData = new FormData()
      formData.append('type', 'shapefile')
      formData.append('mode', this.mode)
      formData.append('name', rawFile.name || 'Import shapefile')
      formData.append('file', rawFile)
      if (this.mode === 'updateOrCreate') {
        formData.append('key_field', this.keyField)
      }
      this.$store.dispatch('datastore/callUpload', {
        url: `datastore-details/${this.detailId}/import`,
        data: formData,
        messages: {
          processing: 'Đang nhập dữ liệu...',
          fail: 'Nhập dữ liệu thất bại',
          failAfterUpload: 'Nhập dữ liệu sau khi upload thất bại',
          abort: 'Có tệp tải lên thất bại, đã hủy nhập dữ liệu',
        },
        cbWhenComplete: () => {
          this.$emit('success')
        },
      })
      this.close()
    },
  },
}
</script>
<style scoped></style>
